import { render, staticRenderFns } from "./parceiro-contador.vue?vue&type=template&id=19c5e8da&scoped=true"
import script from "./parceiro-contador.vue?vue&type=script&lang=js"
export * from "./parceiro-contador.vue?vue&type=script&lang=js"
import style0 from "./parceiro-contador.vue?vue&type=style&index=0&id=19c5e8da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c5e8da",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonComponent: require('/home/luiz/Sistemas/loja/components/ButtonComponent.vue').default})
